import { useEffect, useState } from "react";
import { api, formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Link2, Check, X } from "lucide-react";
import { toast } from "sonner";

export default function Attachments() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/registrations/attachments").then(({ data }) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const decide = async (r, action) => {
    try {
      await api.post(`/registrations/${r.id}/attachment/${action}`);
      toast.success(action === "confirm" ? "Rattachement confirmé — l'administrateur va activer le compte" : "Rattachement refusé");
      load();
    } catch (e) { toast.error(formatError(e)); }
  };

  if (!items.length) return null;
  return (
    <div className="ek-card p-0 border-2 border-[#1F7A63]/30" data-testid="attachments-panel">
      <div className="px-4 py-3 border-b border-[#E2E8F0] flex items-center gap-2">
        <Link2 className="w-5 h-5 text-[#1F7A63]" />
        <h2 className="font-bold" style={{ fontFamily: "Outfit" }}>Enseignants demandant à rejoindre votre école</h2>
        <span className="text-xs font-bold bg-[#1F7A63] text-white rounded-full px-2 py-0.5">{items.length}</span>
      </div>
      {items.map((r) => (
        <div key={r.id} className="px-4 py-3 border-b border-[#E2E8F0] last:border-0 flex items-center gap-3 flex-wrap" data-testid={`attachment-${r.username}`}>
          <div className="flex-1 min-w-[200px]">
            <div className="font-semibold text-sm">{r.name} <span className="text-[#5C736A] font-normal">· {r.telephone}</span></div>
            <div className="text-xs text-[#5C736A]">Niveaux : {(r.niveaux || []).join(", ") || "—"} · demande du {new Date(r.created_at).toLocaleDateString("fr-FR")}</div>
          </div>
          <Button size="sm" variant="outline" onClick={() => decide(r, "refuse")} data-testid={`attachment-refuse-${r.username}`}><X className="w-4 h-4 mr-1" /> Refuser</Button>
          <Button size="sm" onClick={() => decide(r, "confirm")} className="bg-[#1F7A63] hover:bg-[#165c4b] text-white" data-testid={`attachment-confirm-${r.username}`}><Check className="w-4 h-4 mr-1" /> Confirmer</Button>
        </div>
      ))}
    </div>
  );
}
